/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import "lazysizes"
import { startupTheme } from "./js/theme"

// Import modules
import './js/slider'
import './js/toggle'
import './js/cookieBanner'
import './js/overlay'
import { initOnepager } from './js/onepager'

// Import node modules
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()

document.addEventListener('DOMContentLoaded', () => {
  initOnepager()
})
